<!--
 * @Author: zyy
 * @Date: 2022-11-11 17:40:15
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-11 18:34:33
 * @Description: default
-->
<template>
    <div class="account-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
        <a-card :bordered="false">
            <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal" style="margin:10px 0">
                <a-col :span="24" :xl="8">
                    <a-row >
                        <a-col>
                            <p>社区</p>
                        </a-col>
                        <a-col>
                            <a-select v-model="searchQuery.community_id" placeholder="请选择社区" style="width:100%">
                                <a-select-option v-for="item in initData.communityOptions" :key="item.id"
                                    :value="item.id">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="24" :xl="8">
                    <a-space>
                        <a-button type="primary" @click="getList">查询</a-button>
                        <a-button @click="searchReset">重置</a-button>
                    </a-space>
                </a-col>
            </a-row>
            <a-row>
                <a-col style="margin: 0 0 20px 8px">
                    <a-button type="primary" @click="edit()">新增</a-button>
                </a-col>
            </a-row>
            <a-row>
                <a-table :dataSource="table.data" :columns="table.columns" :pagination="ipagination"
                    @change="handlePageChange" rowKey="id">
                    <template slot="image" slot-scope="text, data">
                        <dy-image :src="data.path"></dy-image>
                    </template>
                    <span slot="action" slot-scope="record">
                        <a-button type="link" @click="edit(record)">编辑</a-button>
                        <a-button type="link" style="margin-left: 10px; color: #fb8387" @click="del(record)">删除
                        </a-button>
                    </span>
                </a-table>
            </a-row>
        </a-card>
        <a-modal v-model="modal.show" :title="form.id ? '修改' : '新增'" :confirmLoading="modal.loading" width="50%"
            @ok="confirmModal">
            <a-form-model :form="form" @ok="confirmModal" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">

                <a-form-model-item label="标题">
                    <a-input v-model="form.title" placeholder="请输入名称"></a-input>
                </a-form-model-item>
                <a-form-model-item label="位置信息">
                    <a-input v-model="form.describe" placeholder="请输入位置信息"></a-input>
                </a-form-model-item>
                <a-form-model-item label="位置key">
                    <a-input v-model="form.key" placeholder="请输入位置信息"></a-input>
                </a-form-model-item>
                <a-form-model-item label="链接地址">
                    <a-input v-model="form.url" placeholder="请输入链接地址"></a-input>
                </a-form-model-item>
                <a-form-model-item label="所属社区">
                    <a-select v-model="form.community_id" placeholder="请选择社区">
                        <a-select-option v-for="item in initData.communityOptions" :key="item.id" :value="item.id">
                            {{ item.name }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="图片">
                    <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl"
                        class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange">
                        <dy-image :src="form.path" v-if="form.path" preview></dy-image>
                        <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
                    </a-upload>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
  
<script>
import { TJListMixin } from '@/mixins/list.js'
import AdvertisingService from '@/io/advertising.js'
import CommunityService from '@/io/community.js';
export default {
    mixins: [TJListMixin],
    data() {
        return {
            avatar: {
                loading: false,
            },
            form: {
                id: null,
                title: null,
                type: null,
                path: null,
                key: [],
                region_id: [],
                url: '',
                describe: null,
            },
            initData: {
                communityOptions: [],
            },
            table: {
                data: null,
                columns: [
                    {
                        title: 'id',
                        dataIndex: 'id',
                        align: 'left',
                    },
                    {
                        title: '图片',
                        scopedSlots: { customRender: 'image' },
                    },
                    {
                        title: '标题',
                        dataIndex: 'title',
                    },
                    {
                        title: 'key',
                        dataIndex: 'key',
                    },
                    {
                        title: '位置描述',
                        dataIndex: 'describe',
                        ellipsis: true
                    },
                    {
                        title: '所属社区',
                        customRender: (text) => {
                            return text.community.name
                        }
                    },

                    {
                        title: '操作',
                        scopedSlots: { customRender: 'action' },
                    },
                ],
            },
        }
    },
    mounted() {
        this.initCommunity()
    },
    methods: {
        initCommunity() {
            return CommunityService.listPage().then(res => {
                this.initData.communityOptions = res;
            }).catch(err => { });
        },

        handleChange(info) {
            let status = info.file.status;
            if (status) {
                if (status === 'done') {
                    this.avatar.loading = false;
                    this.form.path = info.file.response.media;
                } else {
                    this.avatar.loading = true;
                }
            }
        },

        getList() {
            AdvertisingService.list(this.searchQuery).then((res) => {
                this.table.data = res.data
            })
        },
        edit(record) {
            if (record) {
                this.form = { ...record }
            } else {
                this.form = {}
            }
            this.modal.show = true
        },
        del(data) {
            this.$confirm({
                title: '提示',
                content: '确认要删除该广告位吗',
                onOk: () => {
                    AdvertisingService.del(data).then((res) => {
                        this.getList()
                        this.$message.success('删除成功')
                    })
                },
            })
        },
        confirmModal() {
            this.modal.loading = true
            if (this.form.id) {
                AdvertisingService.edit(this.form)
                    .then((res) => {
                        this.getList()
                        this.modal.show = false
                        this.$message.success('修改成功')
                    })
                    .finally((res) => {
                        this.modal.loading = false
                    })
            } else {
                AdvertisingService.add(this.form)
                    .then((res) => {
                        this.getList()
                        this.modal.show = false
                        this.$message.success('添加成功')
                    })
                    .finally((res) => {
                        this.modal.loading = false
                    })
            }
        },
    },
}
</script>
  

  </script>
  
<style lang="less" scoped>

</style>